export const parseFocus = (focus: string): { x: number, y: number } => {
  const [x, y] = focus.split(':')[0].split('x')
  return { x: parseFloat(x), y: parseFloat(y) }
}

export const sizeFromImageFilename = (filename: string): { width: number, height: number } => {
  const [width, height] = filename.split('/')[5].split('x')
  return { width: parseInt(width), height: parseInt(height) }
}
